// Generated by Melange

import * as Belt__Belt_List from "melange.belt/belt_List.js";
import * as Belt__Belt_Option from "melange.belt/belt_Option.js";
import * as Buhta_cabinet__Button from "../../../html/Button.js";
import * as Buhta_cabinet__CashboxCartPanel from "./CashboxCartPanel.js";
import * as Buhta_cabinet__CurrencyView from "../../../html/CurrencyView.js";
import * as Buhta_cabinet__FieldNumber from "../../../../util/FieldNumber.js";
import * as Buhta_cabinet__Panel from "../../../html/Panel.js";
import * as Buhta_components__Icons from "../../../../../../../packages/components/src/Icons.js";
import * as Buhta_components__Text from "../../../../../../../packages/components/src/html/Text.js";
import * as Buhta_core__GlobalStateContext from "../../../../../../../packages/core/lib/GlobalStateContext.js";
import * as Caml_obj from "melange.js/caml_obj.js";
import * as Cn from "../../../../../../../vendored/classnames/Cn.js";
import * as Curry from "melange.js/curry.js";
import * as StaticAsset from "../../../../../../../packages/util/lib/StaticAsset.js";
import * as React from "react";
import * as JsxRuntime from "react/jsx-runtime";
import BackArrowSvg from "static/icons/back-arrow.svg";
import CashBlackSvg from "static/icons/cash-black.svg";

const payment__content = "lg:col-start-2 lg:col-end-3 lg:h-full px-6 lg:px-0 py-4 lg:py-16 flex flex-col items-stretch";

const totalPrice = "lg:mt-6 text-center font-semibold text-6xl tracking-wider";

const paymentFields = "flex flex-col border border-solid border-gray-main";

const paymentField = "grid grid-cols-2 first:border-b first:border-solid first:border-gray-main";

const paymentField__name = "px-4 py-3 lg:p-4 pr-0 grid gap-3 grid-cols-auto-1 items-center border-r border-r-solid border-r-gray-main";

const paymentField__input = "px-4 py-3 lg:p-4 flex justify-between items-center relative text-black";

const payment__total = "flex justify-between";

const Styles = {
  payment__content: payment__content,
  totalPrice: totalPrice,
  paymentFields: paymentFields,
  paymentField: paymentField,
  paymentField__name: paymentField__name,
  paymentField__input: paymentField__input,
  payment__total: payment__total
};

function make(param) {
  return function (form) {
    return function (updateForm) {
      return function (stage) {
        return function (kkm) {
          const state = Buhta_core__GlobalStateContext.useGlobalState(undefined);
          const deviceType = state.deviceType;
          const match = React.useState(function () {
                return Buhta_cabinet__FieldNumber.empty;
              });
          const setAmountCashAllocation = match[1];
          const amountCashAllocation = match[0];
          const match$1 = React.useState(function () {
                return Buhta_cabinet__FieldNumber.empty;
              });
          const setAmountCardAllocation = match$1[1];
          const amountCardAllocation = match$1[0];
          const match$2 = React.useState(function () {
                return /* PAYMENT_TYPE_UNSPECIFIED */0;
              });
          const setPaymentType = match$2[1];
          const paymentType = match$2[0];
          const match$3 = React.useState(function () {
                return form.total_amount;
              });
          const setAmountPayable = match$3[1];
          const amountPayable = match$3[0];
          const match$4 = React.useState(function () {
                return 0;
              });
          const setAmountChange = match$4[1];
          const match$5 = React.useState(function () {
                return false;
              });
          const setFormValid = match$5[1];
          const p = kkm.preferences;
          const discountAllowed = p !== undefined ? p.allow_ui_markup_discount : false;
          React.useEffect((function () {
                  const paid = Belt__Belt_Option.getWithDefault(amountCashAllocation.value, 0) + Belt__Belt_Option.getWithDefault(amountCardAllocation.value, 0);
                  const payable = paymentType === /* PAYMENT_TYPE_UNSPECIFIED */0 ? paid - form.total_amount : form.total_amount;
                  Curry._1(setAmountPayable, (function (param) {
                          if (payable <= 0) {
                            return payable;
                          } else {
                            return 0;
                          }
                        }));
                  Curry._1(setAmountChange, (function (param) {
                          if (paymentType === /* PAYMENT_TYPE_UNSPECIFIED */0 && payable > 0) {
                            return payable;
                          } else {
                            return 0;
                          }
                        }));
                  Curry._1(setFormValid, (function (param) {
                          if (paymentType !== /* PAYMENT_TYPE_UNSPECIFIED */0) {
                            return true;
                          } else if (payable >= 0) {
                            return Belt__Belt_Option.getWithDefault(amountCardAllocation.value, 0) - form.total_amount <= 0;
                          } else {
                            return false;
                          }
                        }));
                }), [
                form.total_amount,
                amountCashAllocation,
                amountCardAllocation
              ]);
          const handleFullPayment = function (paymentType) {
            const payment_amount = form.total_amount;
            const payment = {
              payment_type: paymentType,
              amount: payment_amount
            };
            Curry._1(updateForm, {
                  TAG: /* SubmitWithPayment */6,
                  _0: payment
                });
          };
          let tmp;
          if (deviceType === "mobile") {
            tmp = null;
          } else {
            const __x = form.items;
            tmp = JsxRuntime.jsx(Buhta_cabinet__Panel.make, {
                  title: "Корзина",
                  leftActions: {
                    hd: JsxRuntime.jsx("button", {
                          children: JsxRuntime.jsx(BackArrowSvg, {}),
                          className: "panel__toolbar--item back-btn flex items-center",
                          onClick: (function (param) {
                              Curry._1(updateForm, {
                                    TAG: /* TransitionTo */0,
                                    _0: /* Catalog */0
                                  });
                            })
                        }),
                    tl: /* [] */0
                  },
                  shadowed: true,
                  rounded: true,
                  className: "panel--cart",
                  children: JsxRuntime.jsx("div", {
                        children: Belt__Belt_List.toArray(Belt__Belt_List.mapWithIndex(__x, (function (index, item) {
                                    const Key = "cart-item-" + String(index);
                                    return JsxRuntime.jsx(Buhta_cabinet__CashboxCartPanel.CartItemView.make, {
                                                item: item,
                                                index: index,
                                                editable: false
                                              }, Key);
                                  }))),
                        className: "cart-items"
                      })
                });
          }
          let tmp$1;
          tmp$1 = typeof stage === "number" || stage.TAG !== /* Submitting */0 ? false : true;
          let tmp$2;
          tmp$2 = typeof stage === "number" || stage.TAG !== /* Submitting */0 ? false : true;
          const handleCashPayment = function (ev) {
            Curry._1(setPaymentType, (function (param) {
                    return /* PAYMENT_TYPE_UNSPECIFIED */0;
                  }));
            Buhta_cabinet__FieldNumber.set(setAmountCashAllocation, ev.target.value);
          };
          const handleCardPayment = function (ev) {
            Curry._1(setPaymentType, (function (param) {
                    return /* PAYMENT_TYPE_UNSPECIFIED */0;
                  }));
            Buhta_cabinet__FieldNumber.set(setAmountCardAllocation, ev.target.value);
          };
          const handleSubmit = function (_ev) {
            if (paymentType < 3) {
              switch (paymentType) {
                case /* PAYMENT_TYPE_UNSPECIFIED */0 :
                    break;
                case /* PAYMENT_TYPE_CASH */1 :
                    return handleFullPayment(/* PAYMENT_TYPE_CASH */1);
                case /* PAYMENT_TYPE_CARD */2 :
                    return handleFullPayment(/* PAYMENT_TYPE_CARD */2);
                
              }
            }
            if (Belt__Belt_Option.getWithDefault(amountCashAllocation.value, 0) === 0) {
              return handleFullPayment(/* PAYMENT_TYPE_CARD */2);
            } else if (Belt__Belt_Option.getWithDefault(amountCardAllocation.value, 0) === 0) {
              return handleFullPayment(/* PAYMENT_TYPE_CASH */1);
            } else {
              return Curry._1(updateForm, {
                          TAG: /* SubmitWithSplitPayment */7,
                          _0: {
                            hd: {
                              payment_type: /* PAYMENT_TYPE_CASH */1,
                              amount: Belt__Belt_Option.getWithDefault(amountCashAllocation.value, 0)
                            },
                            tl: {
                              hd: {
                                payment_type: /* PAYMENT_TYPE_CARD */2,
                                amount: Belt__Belt_Option.getWithDefault(amountCardAllocation.value, 0)
                              },
                              tl: /* [] */0
                            }
                          }
                        });
            }
          };
          let tmp$3;
          let exit = 0;
          if (typeof stage === "number" || stage.TAG !== /* Submitting */0) {
            exit = 1;
          } else {
            tmp$3 = true;
          }
          if (exit === 1) {
            tmp$3 = paymentType === 2 || paymentType === 1 || match$5[0] ? false : true;
          }
          let tmp$4;
          tmp$4 = typeof stage === "number" || stage.TAG === /* Submitting */0 ? null : JsxRuntime.jsx(Buhta_components__Text.H5.make, {
                  className: "text-alert",
                  children: "err.message"
                });
          return JsxRuntime.jsxs("div", {
                      children: [
                        tmp,
                        JsxRuntime.jsx(Buhta_cabinet__Panel.make, {
                              title: "Оплата",
                              shadowed: true,
                              rounded: true,
                              className: "panel--payment",
                              children: JsxRuntime.jsx("div", {
                                    children: JsxRuntime.jsxs("div", {
                                          children: [
                                            JsxRuntime.jsx(Buhta_components__Text.H1.make, {
                                                  className: totalPrice,
                                                  children: JsxRuntime.jsx(Buhta_cabinet__CurrencyView.make, {
                                                        amount: form.total_amount
                                                      })
                                                }),
                                            JsxRuntime.jsxs("button", {
                                                  children: [
                                                    JsxRuntime.jsx("img", {
                                                          className: "w-6 h-6",
                                                          src: StaticAsset.src(paymentType === /* PAYMENT_TYPE_CASH */1 ? "/static/icons/cash-blue-24.svg" : "/static/icons/cash-black.svg")
                                                        }),
                                                    JsxRuntime.jsx(Buhta_components__Text.H4.make, {
                                                          className: paymentType === /* PAYMENT_TYPE_CASH */1 ? "text-links" : "text-black",
                                                          children: "Наличными"
                                                        })
                                                  ],
                                                  className: Cn.$plus(Cn.$plus("px-4 py-3 lg:p-4 mt-6 lg:mt-10 grid grid-cols-1-auto-1 items-center border rounded", Cn.on("border-links", paymentType === /* PAYMENT_TYPE_CASH */1)), Cn.on("border-gray-main", paymentType !== /* PAYMENT_TYPE_CASH */1)),
                                                  disabled: tmp$1,
                                                  onClick: (function (param) {
                                                      Curry._1(setPaymentType, (function (param) {
                                                              return /* PAYMENT_TYPE_CASH */1;
                                                            }));
                                                      Buhta_cabinet__FieldNumber.set(setAmountCardAllocation, "");
                                                      Buhta_cabinet__FieldNumber.set(setAmountCashAllocation, Buhta_cabinet__FieldNumber.floatToStr(form.total_amount));
                                                    })
                                                }),
                                            JsxRuntime.jsxs("button", {
                                                  children: [
                                                    JsxRuntime.jsx("img", {
                                                          className: "w-6 h-6",
                                                          src: StaticAsset.src(paymentType === /* PAYMENT_TYPE_CARD */2 ? "/static/icons/card-blue-24.svg" : "/static/icons/card24.svg")
                                                        }),
                                                    JsxRuntime.jsx(Buhta_components__Text.H4.make, {
                                                          className: paymentType === /* PAYMENT_TYPE_CARD */2 ? "text-links" : "text-black",
                                                          children: "Картой"
                                                        })
                                                  ],
                                                  className: Cn.$plus(Cn.$plus("px-4 py-3 lg:p-4 mt-2 grid grid-cols-1-auto-1 items-center border rounded", Cn.on("border-links", paymentType === /* PAYMENT_TYPE_CARD */2)), Cn.on("border-gray-main", paymentType !== /* PAYMENT_TYPE_CARD */2)),
                                                  disabled: tmp$2,
                                                  onClick: (function (param) {
                                                      Curry._1(setPaymentType, (function (param) {
                                                              return /* PAYMENT_TYPE_CARD */2;
                                                            }));
                                                      Buhta_cabinet__FieldNumber.set(setAmountCardAllocation, Buhta_cabinet__FieldNumber.floatToStr(form.total_amount));
                                                      Buhta_cabinet__FieldNumber.set(setAmountCashAllocation, "");
                                                    })
                                                }),
                                            JsxRuntime.jsx(Buhta_components__Text.Label.make, {
                                                  className: "flex justify-center mt-6 text-default-gray",
                                                  children: "либо раздельной оплатой"
                                                }),
                                            JsxRuntime.jsx("div", {
                                                  children: JsxRuntime.jsxs(React.Fragment, {
                                                        children: [
                                                          JsxRuntime.jsxs("div", {
                                                                children: [
                                                                  JsxRuntime.jsxs("div", {
                                                                        children: [
                                                                          JsxRuntime.jsxs(Buhta_components__Text.PSmall.make, {
                                                                                className: paymentField__name,
                                                                                children: [
                                                                                  JsxRuntime.jsx(CashBlackSvg, {}),
                                                                                  "Наличными"
                                                                                ]
                                                                              }),
                                                                          JsxRuntime.jsxs("div", {
                                                                                children: [
                                                                                  JsxRuntime.jsx("input", {
                                                                                        className: "font-semibold text-base w-full text-black",
                                                                                        type: "text",
                                                                                        value: amountCashAllocation.text,
                                                                                        onChange: handleCashPayment
                                                                                      }),
                                                                                  JsxRuntime.jsx("div", {
                                                                                        children: "₸",
                                                                                        className: "unit"
                                                                                      })
                                                                                ],
                                                                                className: paymentField__input
                                                                              })
                                                                        ],
                                                                        className: paymentField
                                                                      }),
                                                                  JsxRuntime.jsxs("div", {
                                                                        children: [
                                                                          JsxRuntime.jsxs(Buhta_components__Text.PSmall.make, {
                                                                                className: paymentField__name,
                                                                                children: [
                                                                                  JsxRuntime.jsx(Buhta_components__Icons.IconCard.make, {}),
                                                                                  "Картой"
                                                                                ]
                                                                              }),
                                                                          JsxRuntime.jsxs("div", {
                                                                                children: [
                                                                                  JsxRuntime.jsx("input", {
                                                                                        className: "font-semibold text-base w-full text-black",
                                                                                        type: "text",
                                                                                        value: amountCardAllocation.text,
                                                                                        onChange: handleCardPayment
                                                                                      }),
                                                                                  Belt__Belt_Option.getWithDefault(amountCardAllocation.value, 0) - form.total_amount > 0 ? JsxRuntime.jsxs(Buhta_components__Text.Caption.make, {
                                                                                          className: "absolute bottom-0 text-alert",
                                                                                          children: [
                                                                                            "Не более ",
                                                                                            JsxRuntime.jsx(Buhta_cabinet__CurrencyView.make, {
                                                                                                  amount: form.total_amount
                                                                                                })
                                                                                          ]
                                                                                        }) : null,
                                                                                  JsxRuntime.jsx("div", {
                                                                                        children: "₸",
                                                                                        className: "unit"
                                                                                      })
                                                                                ],
                                                                                className: paymentField__input
                                                                              })
                                                                        ],
                                                                        className: paymentField
                                                                      })
                                                                ],
                                                                className: paymentFields
                                                              }),
                                                          JsxRuntime.jsxs("div", {
                                                                children: [
                                                                  JsxRuntime.jsxs(Buhta_components__Text.PSmall.make, {
                                                                        className: payment__total,
                                                                        children: [
                                                                          "Итого",
                                                                          JsxRuntime.jsx(Buhta_components__Text.H4.make, {
                                                                                className: Cn.fromList({
                                                                                      hd: "payment-total--value",
                                                                                      tl: {
                                                                                        hd: amountPayable === 0 ? "text-black" : "text-alert",
                                                                                        tl: /* [] */0
                                                                                      }
                                                                                    }),
                                                                                children: JsxRuntime.jsx(Buhta_cabinet__CurrencyView.make, {
                                                                                      amount: amountPayable === 0 ? form.total_amount : amountPayable
                                                                                    })
                                                                              })
                                                                        ]
                                                                      }),
                                                                  discountAllowed ? JsxRuntime.jsxs(Buhta_components__Text.PSmall.make, {
                                                                          className: payment__total,
                                                                          children: [
                                                                            "Скидка",
                                                                            JsxRuntime.jsx(Buhta_components__Text.H4.make, {
                                                                                  className: "payment-total--value",
                                                                                  children: JsxRuntime.jsx(Buhta_cabinet__CurrencyView.make, {
                                                                                        amount: 0
                                                                                      })
                                                                                })
                                                                          ]
                                                                        }) : null,
                                                                  JsxRuntime.jsxs(Buhta_components__Text.PSmall.make, {
                                                                        className: payment__total,
                                                                        children: [
                                                                          "Сдача",
                                                                          JsxRuntime.jsx(Buhta_components__Text.H4.make, {
                                                                                className: "payment-total--value",
                                                                                children: JsxRuntime.jsx(Buhta_cabinet__CurrencyView.make, {
                                                                                      amount: match$4[0]
                                                                                    })
                                                                              })
                                                                        ]
                                                                      }),
                                                                  JsxRuntime.jsx(Buhta_cabinet__Button.make, {
                                                                        size: deviceType === "mobile" ? "m" : "l",
                                                                        state: Caml_obj.caml_equal(stage, {
                                                                              TAG: /* Submitting */0,
                                                                              _0: /* Split */1
                                                                            }) ? "Loading" : "Default",
                                                                        className: "mt-3 lg:mt-6",
                                                                        disabled: tmp$3,
                                                                        isWide: true,
                                                                        onClick: handleSubmit,
                                                                        children: "Оплатить заказ"
                                                                      }),
                                                                  tmp$4
                                                                ],
                                                                className: "mt-auto pt-6 lg:pt-10.5"
                                                              })
                                                        ]
                                                      }),
                                                  className: "grow flex flex-col justify-between mt-6"
                                                })
                                          ],
                                          className: payment__content
                                        }),
                                    className: "lg:grid lg:grid-cols-2-4-2"
                                  })
                            })
                      ],
                      className: Cn.$plus(Cn.on("mt-4", deviceType === "mobile"), Cn.on("grid grid-cols-4-8 gap-2", deviceType !== "mobile"))
                    });
        };
      };
    };
  };
}

function CashboxPayment(Props) {
  return Curry._3(make(Props.org)(Props.form), Props.updateForm, Props.stage, Props.kkm);
}

const make$1 = CashboxPayment;

export {
  Styles ,
  make$1 as make,
}
/* Buhta_cabinet__Button Not a pure module */
